module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/rings/couture-19889888234b6c8d378b0759cd3b95e1.webp";